module.exports = __webpack_public_path__ + "img/icon-innovation.206dda3a.svg";